// extracted by mini-css-extract-plugin
module.exports = {"progressContainer":"OnboardingProgress_progressContainer__EBT_3","progressBar":"OnboardingProgress_progressBar__CE2mR"};